import React, { useEffect, useState } from 'react'
import { auth } from '../../services/firebase'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { CUSTOMER_KEY } from '../../atoms/customerAtom'

const AuthContext = React.createContext()

export const useAuth = () => {
  return React.useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLogin, setUserLogin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setUserLogin(true);
      } else {
        setUser(null);
        setUserLogin(false);
        // Clear any local storage on auth state change
        localStorage.removeItem(CUSTOMER_KEY);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setUserLogin(false);
      localStorage.removeItem(CUSTOMER_KEY);
    } catch (error) {
      console.error('Error signing out:', error);
      setError(error);
    }
  };

  const value = {
    user,
    userLogin,
    loading,
    error,
    handleSignOut
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}



